import React, { useState } from "react";
import {
  Container,
  Typography,
  IconButton,
  Collapse
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import projectData from "../works/projects.json";
import "./Works.css";

const useStyles = makeStyles((theme) => ({
  main: {
    width: "100%",
    padding: theme.spacing(4, 0),
  },
  sectionTitle: {
    marginBottom: theme.spacing(4),
    textAlign: "center",
  },
  toggleContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
  toggleButton: {
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: "transparent",
      color: theme.palette.secondary.main,
    },
  },
}));

export const Works = () => {
  const classes = useStyles();
  const [showAll, setShowAll] = useState(false);
  const [expandedProject, setExpandedProject] = useState(null);

  const toggleProjectExpand = (id) => {
    setExpandedProject(expandedProject === id ? null : id);
  };

  const displayedProjects = showAll ? projectData : projectData.slice(0, 3);

  return (
    <section id="works">
      <Typography variant="h3" className={classes.sectionTitle}>
        PROJECTS
      </Typography>
      <Container component="main" className={classes.main} maxWidth="lg">
        {displayedProjects.map((project) => (
          <div className="project" key={project.id}>
            <div className="__img_wrapper">
              <div className="laptop-border">
                <img
                  className="project-image"
                  src={project.image}
                  alt={project.alter}
                  loading="lazy"
                />
              </div>
            </div>
            <div className="__content_wrapper">
              <h3 className="title">{project.title}</h3>
              <Collapse in={expandedProject === project.id}>
                <p className="description">{project.description}</p>
              </Collapse>
              <IconButton
                onClick={() => toggleProjectExpand(project.id)}
                className={classes.toggleButton}
                aria-label={
                  expandedProject === project.id ? "Show less" : "Show more"
                }
              >
                {expandedProject === project.id ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </IconButton>
            </div>
          </div>
        ))}
        <div className={classes.toggleContainer}>
          <IconButton
            onClick={() => setShowAll(!showAll)}
            className={classes.toggleButton}
          >
            {showAll ? (
              <>
                <ExpandLessIcon />
                <span style={{ marginLeft: 8 }}>Show Less</span>
              </>
            ) : (
              <>
                <ExpandMoreIcon />
                <span style={{ marginLeft: 8 }}>Show More</span>
              </>
            )}
          </IconButton>
        </div>
      </Container>
    </section>
  );
};
